export default __webpack_public_path__ + "static/media/blogs_image.08bcc48d.svg";